import React, { useRef } from "react";
import { Box, Button, Typography, IconButton, InputLabel } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveIcon from "@mui/icons-material/Remove";

export const ImageUploadField = ({
  label,
  multiple = false,
  images,
  onChange,
  onRemove,
  onPreview,
  labelSx = {},
}) => {
  const fileInputRef = useRef();

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const handleFileChange = (e) => {
    if (multiple) {
      onChange([...e.target.files]);
    } else {
      onChange(e.target.files[0]);
    }
  };

  const handleRemove = (idx) => {
    resetFileInput();
    onRemove(idx);
  };

  const renderImageList = () => {
    const imageArray = multiple ? images : images ? [images] : [];
    return imageArray.map((img, idx) => (
      <Box
        key={idx}
        sx={{ display: "flex", alignItems: "center", mx: 1, my: 0.5 }}
      >
        <Typography sx={{ mx: 1 }}>{img.name}</Typography>
        <Button
          variant="outlined"
          size="small"
          sx={{ mx: 1 }}
          onClick={() => onPreview(img)}
        >
          Preview
        </Button>
        <IconButton
          color="primary"
          onClick={() => handleRemove(multiple ? idx : null)}
        >
          <RemoveIcon />
        </IconButton>
      </Box>
    ));
  };

  return (
    <>
      <InputLabel sx={{ mt: 2, ...labelSx }}>{label}</InputLabel>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: multiple ? "wrap" : "nowrap",
          mb: 2,
        }}
      >
        <input
          type="file"
          accept="image/*"
          multiple={multiple}
          style={{ display: "none" }}
          ref={fileInputRef}
          onChange={handleFileChange}
        />
        {(multiple || !images) && (
          <IconButton
            color="primary"
            onClick={() => fileInputRef.current.click()}
          >
            <AddCircleOutlineIcon />
          </IconButton>
        )}

        {/* Image display section */}
        {images && !multiple && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ mx: 1 }}>{images.name}</Typography>
            <Button
              variant="outlined"
              size="small"
              sx={{ mx: 1 }}
              onClick={() => onPreview(images)}
            >
              Preview
            </Button>
            <IconButton color="primary" onClick={() => handleRemove(null)}>
              <RemoveIcon />
            </IconButton>
          </Box>
        )}
        {multiple && renderImageList()}
      </Box>
    </>
  );
};
